import {Component, OnDestroy, OnInit} from '@angular/core';
import {AlertService} from "../services";
import {ComponentTitleService} from "../services/componentTitle.service";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';

@Component({
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss']
})

export class TabsComponent implements OnDestroy, OnInit {
    constructor(
        private alertService: AlertService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService
    ) {
        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
    }

    ngOnInit() {

    }

    ngOnDestroy(): void {

    }
}
